import Sticky from 'common/sticky/sticky';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { isToggleEnabled } from 'react-awesome-feature-toggles/dist/feature-toggles';
import styled, { css } from 'styled-components';
import { Flex } from 'ui';
import useDeepCompareEffect from 'use-deep-compare-effect';
import Paging from '../../common/gantt/components/paging/paging';
import { updateFilters } from '../../common/gantt/containers/gantt-actions';
import { additionalTabTypes } from '../../utils/app-configs';
import { isObjectNullOrEmpty } from '../../utils/helpers';
import FilterButton from '../../worklist/components/toolbar/filter-button';
import PlanningBoardMenu from '../containers/planning-board-menu-container';
import PeriodDropdownContainer from '../containers/planning-board-period-dropdown-container';
import PublishButton from '../containers/planning-board-publish-button-container';
import TemplateDropdownContainer from '../containers/planning-board-template-dropdown-container';
import { RouteOptimisationButton } from './planning-board-route-optimisation';
import TravelToggle from './planning-board-travel-toggle';

const StyledToolbarSection = styled(Flex)`
  ${p =>
    !p.noBorder &&
    css`
      border-left: 1px solid ${p.theme.colors.border};
    `};
  padding-left: ${p => p.noPaddingLeft ? '0px' : '10px'};
  height: 34px !important;
  align-items: center;
  ${p =>
    p.paddingRight &&
    css`
      padding-right: 10px;
    `}
`;

const PlanningBoardToolbar = ({
  split = false,
  menuVisible,
  fullScreen,
  isLoadingBoardData,
  activeFilters,
  filters,
  boardData = {},
}) => {
  const [calculateTravelTime, setCalculateTravelTime] = useState(false);

  useDeepCompareEffect(() => {
    setCalculateTravelTime(isObjectNullOrEmpty(boardData) || boardData?.calculateTravelTime);
  }, [boardData]);

  const extraStyles = css`
    background-color: rgb(245, 248, 250) !important;
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: 0px !important;
    z-index: 120;
    box-shadow: none !important;
    width: 100%;
    ${split
      ? `
            top: 0px !important;
            margin-top: 0px !important;
            border-bottom: 1px solid #d9e0e6;
          `
      : ''
    }

    ${!split
      ? `
            top: ${fullScreen ? '0px' : '109px'} !important;
            border-bottom: 1px solid #d9e0e6;
          `
      : ''
    }
  `;

  return (
    <Sticky
      menuVisible={menuVisible}
      extraStyles={extraStyles}
      translateYEnd={fullScreen ? '0px' : '-54px'}
    >
      <Flex jcfs aifs data-test-id='planning-board-toolbar'>
        <StyledToolbarSection noPaddingLeft={true} paddingRight={true} noBorder={true}>
          <PeriodDropdownContainer />
        </StyledToolbarSection>
        <StyledToolbarSection noPaddingLeft={true}>
          <TemplateDropdownContainer
            isLoading={isLoadingBoardData}
            isPlanningBoard={true}
          />
        </StyledToolbarSection>
        <StyledToolbarSection noPaddingLeft={true}>
          <Paging addShowingLabel={false} />
        </StyledToolbarSection>
        <PublishButton />
        <StyledToolbarSection noPaddingLeft={true} paddingRight={true} noBorder={true}>
          <FilterButton
            isLoading={isLoadingBoardData}
            urlKey='ganttfilterselect'
            updateCb={updateFilters}
            additionalActionTypes={[additionalTabTypes.rows]}
            activeFilters={activeFilters}
            filters={filters}
          />
        </StyledToolbarSection>
        {isToggleEnabled('useRealtimeEventsForGanttRouteOptimisation') &&
          isToggleEnabled('forwardPlanning') &&
          isToggleEnabled('forwardPlanningJobs') &&
          <RouteOptimisationButton />}
        {!calculateTravelTime &&
          <StyledToolbarSection noPaddingLeft={true}>
            <TravelToggle />
          </StyledToolbarSection>
        }
        <PlanningBoardMenu />
      </Flex>
    </Sticky>
  );
};

PlanningBoardToolbar.propTypes = {
  split: PropTypes.bool,
  menuVisible: PropTypes.bool,
  fullScreen: PropTypes.bool,
  isLoadingBoardData: PropTypes.bool,
  activeFilters: PropTypes.object,
  filters: PropTypes.array,
  boardData: PropTypes.object,
};

export default PlanningBoardToolbar;
